var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('skills-details',{attrs:{"bus":_vm.bus,"isRequiredStep":_vm.isRequiredStep,"minimumEntries":_vm.minimumEntries,"isLastStep":_vm.isLastStep},on:{"disable-next-button":_vm.disableNext,"go-to-next":_vm.goToNext}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }